export default __webpack_public_path__ + "static/media/CSIO_OurMembers.5208d201.pdf";